/**
 * @whatItDoes predefined enum of products from where config will be fetched.
 *
 * @experimental
 */
export enum ClientConfigProductName {
    BINGO = 'bingo',
    MOKABINGO = 'mokabingo',
    CASINO = 'casino',
    LOTTO = 'lotto',
    HORSERACING = 'horseracing',
    ESPORTS = 'esports',
    HOST = 'host',
    POKER = 'poker',
    PORTAL = 'portal',
    PROMO = 'promo',
    ENGAGE = 'engagement',
    SF = 'sf',
    SPORTS = 'sports',
    VIRTUALSPORTS = 'virtualsports',
    CORALSPORTS = 'coralsports',
    OZONE = 'ozone',
    PAYMENTS = 'payments',
}

/**
 * Options for {@link ClientConfig} and {@link LazyClientConfig}.
 *
 * @param key key corresponds to the name from the server
 * @param product indicates from where config will be fetched. For {@link ClientConfig} it is optional and default value is host, for {@link LazyClientConfig} is mandatory
 * @param realod indicates if client config will be reloaded on login
 *
 * @experimental
 */
export type ClientConfigOptions = {
    key: string;
    product?: ClientConfigProductName;
    reload?: boolean;
};

export const defaultClientConfigOptions: ClientConfigOptions = {
    product: ClientConfigProductName.HOST,
    key: '',
};
